<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Microsoft YaHei";
  }

  html,
  body {
    margin: 0;
    padding: 0;
    font-size: 14px;
    color: #333333;
    height: 100%;
  }
  /*body::-webkit-scrollbar { display: none; }*/
  body { -ms-overflow-style: none; height: 100%; overflow: auto; }
  img {
    border: none;
  }

  input {
    outline: none;
  }

  a {
    text-decoration: none;
    color: black;
  }

  h2{
    font-size: 30px;
    color: #4A4A4A;
    letter-spacing: 6px;
    text-align: center;
    line-height: 30px;
    font-weight: 500 ;
  }

  i {
    font-style: normal;
  }
  ::-webkit-scrollbar {
    width: 0px;
  }
  ul,
  li {
    list-style: none;
  }
  .t-container{
    padding: 20px 0;
    height: 70px;
  }
  .t-container .t-title{
    text-align: center;
    color:#ffffff;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .t-container .main-content{
    width: 80%;
    margin:0 auto;
    min-width: 700px;
    height: calc(100% - 112px);
  }
  .el-row{
    height: 100%;
  }

  .el-col-12{
    height: 100%;
  }



  .content-box {
    width: 100%;
    height: calc(100% - 80px);
  }

  .content {
    width: 100%;
    box-sizing: border-box;
  }

  .content-collapse {
    left: 65px;
  }

  .crumbs {
    margin-bottom: 20px;
  }

  .pagination {
    margin: 20px 0;
    text-align: right;
  }

  .plugins-tips {
    padding: 20px 10px;
    margin-bottom: 20px;
  }

  .el-button+.el-tooltip {
    margin-left: 10px;
  }

  .el-table tr:hover {
    background: #f6faff;
  }

  .mgb20 {
    margin-bottom: 20px;
  }

  .move-enter-active,
  .move-leave-active {
    transition: opacity .5s;
  }

  .move-enter,
  .move-leave {
    opacity: 0;
  }

  /*BaseForm*/

  .form-box {
    width: 600px;
  }

  .form-box .line {
    text-align: center;
  }

  .el-time-panel__content::after,
  .el-time-panel__content::before {
    margin-top: -7px;
  }

  .el-time-spinner__wrapper .el-scrollbar__wrap:not(.el-scrollbar__wrap--hidden-default) {
    padding-bottom: 0;
  }

  /*Upload*/

  .pure-button {
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #fff;
    border-radius: 3px;
  }

  .g-core-image-corp-container .info-aside {
    height: 45px;
  }

  .el-upload--text {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .el-upload--text .el-icon-upload {
    font-size: 67px;
    color: #97a8be;
    margin: 40px 0 16px;
    line-height: 50px;
  }

  .el-upload--text {
    color: #97a8be;
    font-size: 14px;
    text-align: center;
  }

  .el-upload--text em {
    font-style: normal;
  }

  /*VueEditor*/

  .ql-container {
    min-height: 400px;
  }

  .ql-snow .ql-tooltip {
    transform: translateX(117.5px) translateY(10px) !important;
  }

  .editor-btn {
    margin-top: 20px;
  }

  /*markdown*/

  .v-note-wrapper .v-note-panel {
    min-height: 500px;
  }

  /*常用样式*/
  .flr{
    float: right;
  }

  .fll{
    float: left;
  }
  .show{
    display: block;
  }

  .hide{
    display: none;
  }


  .more{
    text-align: center;
    font-size: 14px;
    color: #9B9B9B;
    letter-spacing: 0;
    line-height: 14px;
  }

  .clear-both{
    clear: both;
  }

  /*字体颜色*/
  .font-c-white{
    color: #ffffff;
  }

  @media (min-width: 1400px){
    .container {
      width: 1400px;
    }
  }
  @media (min-width: 1200px){
    .container {
      width: 1400px;
    }
  }
  @media (min-width: 992px){
    .container {
      width: 1400px;
    }
  }

  #app{
    width: 100%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue